// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-fixed .price-wallet[data-v-b1dcf72e],.header-fixed .price-wallet i[data-v-b1dcf72e]{color:#fff}.price-wallet[data-v-b1dcf72e]{padding-right:12px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:6px!important;background-color:rgba(51,143,205,.55)}.price-walletButton[data-v-b1dcf72e]{border-radius:6px 0 0 6px!important}", ""]);
// Exports
module.exports = exports;
